import { border, boxShadow, grid, layout, position, system } from 'styled-system';
import { Box } from 'reflexbox/styled-components';
import styled from 'styled-components';

// @NOTE: color, space, typography, and flexbox are provided in entirety by Reflexbox.
const StyledBox = styled(Box)`
  ${border}
  ${boxShadow}
  ${grid}
  ${layout}
  ${position}
  ${system({
    gap: { property: 'gap', scale: 'space' },
    rowGap: { property: 'rowGap', scale: 'space' },
    columnGap: { property: 'columnGap', scale: 'space' },
  })}
`;

export { StyledBox as Box };
